import clone from 'lodash.clone';
import number from './number';

const decimal = clone(number);
decimal.format = function (v) {
  if (v === undefined || v === null) return '';
  return parseFloat(Math.round(v * 100) / 100).toFixed(2);
};

export default decimal;



// WEBPACK FOOTER //
// ./src/assets/js-on/vue-good-table/components/types/decimal.js